const getFileUrl = (filename: string) => {
  return `/public/${filename}`;
};

export default getFileUrl;
